export default __webpack_public_path__ + "static/wynajem-d2b54b6f1a1ab4380b7816f1804c8cd7.webp";